import { authTypes } from '../auth/types'
import { ApplianceType, Item, ItemByCategory } from '../types'
import { ItemsActions, ItemsType, itemsTypes, ScanLabel } from './types'

const initialState: ItemsType = {
  items: [],
  itemsByCategory: [],
  inspectionItems: [],
  applianceTypes: null,
  applianceTagData: null
}

const reducer = (state = initialState, action: ItemsActions): ItemsType => {
  const { type, payload } = action

  switch (type) {
    case authTypes.LOGIN_REQUEST: { return initialState }
    case authTypes.LOGOUT_REQUEST: { return initialState }

    case itemsTypes.SET_ITEMS: {
      return {
        ...state,
        items: payload as Item[]
      }
    }
    case itemsTypes.SET_INSPECTION_ITEMS: {
      return {
        ...state,
        inspectionItems: payload as Item[]
      }
    }
    case itemsTypes.SET_ITEMS_BY_CATEGORY: {
      Object.assign(state?.itemsByCategory)

      return {
        ...state,
        itemsByCategory: payload as ItemByCategory[]
      }
    }
    case itemsTypes.SET_APPLIANCE_TYPES: {
      return {
        ...state,
        applianceTypes: payload as ApplianceType
      }
    }
    case itemsTypes.SET_APPLIANCE_TAG_DATA: {
      return {
        ...state,
        applianceTagData: payload as ScanLabel
      }
    }

    default:
      return state
  }
}

export default reducer
